import Badge from 'react-bootstrap/esm/Badge';
import ListGroup from 'react-bootstrap/ListGroup';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
// import Form from 'react-bootstrap/Form'
import Swal from 'sweetalert2';
import './Post.css'
// import Spinner from 'react-bootstrap/esm/Spinner';
export const Post = (props) => {
    const { post, user, allusers, getAllPosts, profile, getProfile } = props;
    const [modalShow, setModalShow] = useState(false)



    const navigate = useNavigate();
    const timeDiff = (curr, posted) => {
        var msperMin = 60 * 1000;
        var msperHr = 60 * msperMin;
        var msperDay = 24 * msperHr;
        var msperWeek = 7 * msperDay;
        var msperMonth = 30 * msperDay;
        var msperYear = 365 * msperDay;

        var diff = curr - posted;
        if (diff < msperMin) {
            return Math.round(diff / 1000) === 1 ? (Math.round(diff / 1000) + " second ago") : (Math.round(diff / 1000) + " seconds ago");
        } else if (diff < msperHr) {
            return Math.round(diff / msperMin) === 1 ? (Math.round(diff / msperMin) + " minute ago") : (Math.round(diff / msperMin) + " minutes ago");

        } else if (diff < msperDay) {
            return Math.round(diff / msperHr) === 1 ? (Math.round(diff / msperHr) + " hour ago") : (Math.round(diff / msperHr) + " hours ago");

        } else if (diff < msperWeek) {
            return Math.round(diff / msperDay) === 1 ? (Math.round(diff / msperDay) + " day ago") : (Math.round(diff / msperDay) + " days ago");

        } else if (diff < msperMonth) {
            return Math.round(diff / msperWeek) === 1 ? (Math.round(diff / msperWeek) + " week ago") : (Math.round(diff / msperWeek) + " weeks ago");

        } else if (diff < msperYear) {
            return Math.round(diff / msperMonth) === 1 ? (Math.round(diff / msperMonth) + " month ago") : (Math.round(diff / msperMonth) + " months ago");
        } else {
            return Math.round(diff / msperYear) === 1 ? (Math.round(diff / msperYear) + " year ago") : (Math.round(diff / msperYear) + " years ago");
        }

    }

    const handleViewProfile = async (id) => {
        console.log("clicked", id)
        // return Swal.fire("get","","info")
        let { data, status } = await axios.get(`https://maestrohub-backend.onrender.com/api/profile/users/${id}`)
        console.log(data, status)
        if (status === 200) {
            let profile;
            if (data.profile) {
                profile = data.profile._id;
                navigate(`/users/${profile}`)
            } else {
                return Swal.fire(data.msg, "", "info")
            }
        }



    }

    const handleDelete = async (postID) => {
        // e.preventDefault();
        console.log("Inside delete")
        let { data, status } = await axios.delete(`https://maestrohub-backend.onrender.com/api/post/${postID}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) {
            Swal.fire(data.msg, "", "success");
            getAllPosts();
        } else {
            Swal.fire("Error", "", "error");
            navigate("/feed");
        }
    }

    const handleFollow = async (id) => {
        // console.log("HandleFollow")
        const { data, status } = await axios.put(`https://maestrohub-backend.onrender.com/api/profile/${id}`, {}, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) Swal.fire(data.msg, "", "info")
        // getUser();
        // setprofile(data.userprofile)
        getProfile();


    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>Likes: </h4>
                    {/* {props.likes.map(like=>{
                return <h2>{like}</h2>
              })} */}
                    {props.likes.map((like) => {

                        return allusers.map((profile) => {
                            return profile.user._id === like ? 
                                <Card onClick={() => navigate(`/users/${profile._id}`)}>
                                    <Card.Body style={{
                                        fontWeight: "bold"
                                    }}><img src={`${profile.user.avatar}`} height={"25vh"} width={"30vh"} alt={`${profile.user.name}'s avatar`}></img> {profile.user.name}</Card.Body>
                                </Card>
                            : <></>
                        })
                    })}
                </Modal.Body>
            </Modal>
        );
    }


    return (
        <div className='post-indi'>
        <Card className='m-3 ' style={{
            maxWidth:'100%'
        }}>
            <Card.Title className='post-title' style={{
                alignSelf: "center",
                fontSize: "3.5vh"
            }}>{post.title}</Card.Title>
            <Card.Img variant="top"
                src={`${post.image}`}
                alt={`Image By ${post.user.name} regarding ${post.title}`}
                style={{
                    height:'40vh',
                    objectFit:'contain'
                }}
            />
            <Card.Body>
                <Card.Text className='p-2' style={{
                    fontSize: "2.5vh"
                }}>
                    {post.description}

                </Card.Text>
            </Card.Body>
            <ListGroup className="list-group-flush">
                <ListGroup.Item style={{
                    fontWeight: "bolder",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",


                }}>
                    <div style={{
                        cursor: "pointer"
                    }} onClick={handleViewProfile.bind(this, post.user._id)}>


                        <img src={post.avatar} alt="" height={"25vh"} width={"30vh"} /> {post.user.name}{' '}

                        {profile.trainer ? <Badge bg='secondary' className='m-2'>Trainer</Badge> : ""}
                    </div>
                    {post.user._id === user._id ? "" :
                        <div >
                            {profile ? <Button variant={`${profile.following.includes(post.user._id) ? "danger" : "primary"}`} onClick={handleFollow.bind(this, post.user._id)}>{`${profile.following.includes(post.user._id) ? "Unfollow" : "Follow"}`}</Button> : <></>}
                        </div>}
                </ListGroup.Item>
                <div className="container row likes-comments">

                    <div className='col-3' style={{
                        textAlign: "center",
                    }}>
                        <div>
                        {post.likes.includes(user._id) ? <i className="fa-solid fa-heart" style={{
                            cursor: "pointer",
                            color: "red"
                        }} onClick={async () => {
                            let { status } = await axios.put(`https://maestrohub-backend.onrender.com/api/post/likes/${post._id}`, {}, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
                                }
                            }

                            );
                            if (status === 200) getAllPosts();

                        }}></i> : <i className="fa-regular fa-heart" style={{
                            cursor: "pointer"
                        }} onClick={async () => {
                            let { status } = await axios.put(`https://maestrohub-backend.onrender.com/api/post/likes/${post._id}`, {}, {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
                                }
                            });
                            if (status === 200)
                                getAllPosts();
                        }}></i>}{' '}<span style={{
                            cursor: "pointer"
                        }} onClick={() => setModalShow(true)}>{post.likes.length === 1 ? "1 Like" : `${post.likes.length} Likes`}</span>
                        
                        <MyVerticallyCenteredModal
                            show={modalShow}
                            onHide={() => setModalShow(false)
                            }
                            likes={post.likes}
                        />
                        </div>
                    </div>
                    <div className='col-3' style={{
                        // display:"flex",
                        textAlign: "center",
                        // justifyContent: "center"
                    }}><i className="fa-regular fa-comment" style={{
                        cursor: "pointer"
                    }}></i> <span style={{ cursor: 'pointer' }} onClick={() => navigate(`/p/${post._id}`)}>{post.comments.length === 1 ? "1 Comment" : `${post.comments.length} Comments`}</span></div>
                    {post.user._id === user._id ? <div className='col-6 justify-content-end'>
                        <Button variant='danger' onClick={handleDelete.bind(this, post._id)} style={{
                            alignItems: "center",
                            justifyContent: "center",
                            margin:'2px auto'
                        }}>
                            <i className="fa-solid fa-trash"></i> <span className='post-delete'>Delete Post</span>
                        </Button>
                    </div> : ""}
                </div>
            </ListGroup>
            <div className='timer text-muted'>

                {timeDiff(new Date(), new Date(post.createdAt))}
            </div>
        </Card>
        </div>
    )
}
